import { render, staticRenderFns } from "./ReservaListaItem.vue?vue&type=template&id=b9cba414&"
import script from "./ReservaListaItem.vue?vue&type=script&lang=js&"
export * from "./ReservaListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports